@if (pages.length > 1) {
    <div class="d-flex justify-content-between">
        <button type="button" class="btn" [disabled]="activePage === 1" (click)="changePageToPrev()">
            <i class="fas fa-arrow-left me-2"></i>
            {{ 'Previous' | translate }}
        </button>
        <div class="btn-group btn-group-sm">
            @if (activePage > 3) {
                <button type="button" class="btn" (click)="changePage(1)">1</button>
                @if (activePage > 4) {
                    <div class="dots">…</div>
                }
            }
            @for (page of pages; track page) {
                @if (page < activePage + 3 && page > activePage - 3) {
                    <button type="button" class="btn" [class.active]="activePage === page" (click)="changePage(page)">
                        {{ page }}
                    </button>
                }
            }
            @if (activePage <= pageCount - 3) {
                @if (activePage <= pageCount - 4) {
                    <div class="dots">…</div>
                }
                <button type="button" class="btn" (click)="changePage(pageCount)">
                    {{ pageCount }}
                </button>
            }
        </div>
        <button type="button" class="btn" [disabled]="activePage === pageCount" (click)="changePageToNext()">
            {{ 'Next' | translate }}
            <i class="fas fa-arrow-right ms-2"></i>
        </button>
    </div>
}
<sb-entries-info [activePage]="activePage" [itemCount]="itemCount" [pageSize]="pageSize"> </sb-entries-info>
